import { render } from "./PvpHint.vue?vue&type=template&id=773b7984&scoped=true"
import script from "./PvpHint.vue?vue&type=script&lang=ts"
export * from "./PvpHint.vue?vue&type=script&lang=ts"

import "./PvpHint.vue?vue&type=style&index=0&id=773b7984&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-773b7984"

export default script